module.exports = __webpack_public_path__ + "static/media/Redux.41200644.png";